import React, { Suspense, lazy, useEffect } from "react";
import { Router } from "react-router-dom";
import history from "./Services/history";
import makeStyles from "@mui/styles/makeStyles";

const Home = lazy(() => import("./Components/Home"));

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex"
  }
}));

const App = ({ hideLoader }) => {
  const classes = useStyles();

  useEffect(() => {
    hideLoader();
  });

  return (
    <div className={classes.root}>
      <Router history={history}>
        <Suspense fallback={null}>
          <Home />
        </Suspense>
      </Router>
    </div>
  );
};

export default App;
